import React from 'react';
const Returns = () => <div className="p-8"><h1 className="text-2xl font-bold">Returns Page</h1></div>;
export default Returns; 